import React from 'react'


const Feedback = () => {
    const form = process.env.REACT_APP_FEEDBACK_FORM_URL;
    return (
        <div>
         <iframe className="uk-align-center" src={form} width="640" height="1179" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
        </div>
    )
}

export default Feedback